import { render, staticRenderFns } from "./CPARCC.vue?vue&type=template&id=8be48eba&"
import script from "./CPARCC.vue?vue&type=script&lang=js&"
export * from "./CPARCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports